const dist = (x1,y1,x2,y2) => Math.sqrt(Math.pow(x1-x2, 2) + Math.pow(y1-y2, 2));
function formatPoints(points, close) {
  points = [...points];
  // so that coords can be passed as objects or arrays
  if (!Array.isArray(points[0])) {
    points = points.map(({ x, y }) => [x, y]);
  }

  if (close) {
    const lastPoint = points[points.length - 1];
    const secondToLastPoint = points[points.length - 2];

    const firstPoint = points[0];
    const secondPoint = points[1];

    points.unshift(lastPoint);
    points.unshift(secondToLastPoint);

    points.push(firstPoint);
    points.push(secondPoint);
  }

  return points.flat();
}

function spline(points = [], tension, close = true, list=false) {
    points = formatPoints(points, close);

    const size = points.length;
    const last = size - 4;
    
    const startPointX = close ? points[2] : points[0];
    const startPointY = close ? points[3] : points[1];
    
    let _path = [[startPointX, startPointY]];
    let path = "M" + [startPointX, startPointY];
    
    const startIteration = close ? 2 : 0;
    const maxIteration = close ? size - 4 : size - 2;
    const inc = 2;
    
    for (let i = startIteration; i < maxIteration; i += inc) {
        const x0 = i ? points[i - 2] : points[0];
        const y0 = i ? points[i - 1] : points[1];
        
        const x1 = points[i + 0];
        const y1 = points[i + 1];
        
        const x2 = points[i + 2];
        const y2 = points[i + 3];
        
        const x3 = i !== last ? points[i + 4] : x2;
        const y3 = i !== last ? points[i + 5] : y2;

        
        let _tension = tension; //tension * Math.pow(dist(x1,y1,x2,y2) / (window.splineDist || 300), 1/5.0);

        const cp1x = x1 + ((x2 - x0) / 6) * _tension;
        const cp1y = y1 + ((y2 - y0) / 6) * _tension;
        
        const cp2x = x2 - ((x3 - x1) / 6) * _tension;
        const cp2y = y2 - ((y3 - y1) / 6) * _tension;
        
        path += "C" + [cp1x, cp1y, cp2x, cp2y, x2, y2];
        _path.push([cp1x, cp1y, cp2x, cp2y, x2, y2]);
    }
    
    return list ? _path : path;
}

function listSpline(points = [], tension=1.8, close = true) {
    points = formatPoints(points, close);

    const size = points.length;
    const last = size - 4;
    
    const startPointX = close ? points[2] : points[0];
    const startPointY = close ? points[3] : points[1];
    
    let _path = [[startPointX, startPointY]];
    let path = "M" + [startPointX, startPointY];
    
    const startIteration = close ? 2 : 0;
    const maxIteration = close ? size - 4 : size - 2;
    const inc = 2;
    
    for (let i = startIteration; i < maxIteration; i += inc) {
        const x0 = i ? points[i - 2] : points[0];
        const y0 = i ? points[i - 1] : points[1];
        
        const x1 = points[i + 0];
        const y1 = points[i + 1];
        
        const x2 = points[i + 2];
        const y2 = points[i + 3];
        
        const x3 = i !== last ? points[i + 4] : x2;
        const y3 = i !== last ? points[i + 5] : y2;

        
        let _tension = tension; //tension * Math.pow(dist(x1,y1,x2,y2) / (window.splineDist || 300), 1/5.0);

        const cp1x = x1 + ((x2 - x0) / 6) * _tension;
        const cp1y = y1 + ((y2 - y0) / 6) * _tension;
        
        const cp2x = x2 - ((x3 - x1) / 6) * _tension;
        const cp2y = y2 - ((y3 - y1) / 6) * _tension;
        
        _path.push([cp1x, cp1y, cp2x, cp2y, x2, y2]);
    }
    
    return _path.flat(2);
}



export { spline, listSpline };
